import { RequestService } from '../../../../common/services/RequestService';
import { UPDATE_VEHICLE } from '../constants';
import {
  dataAdjustmentCardResponse,
  dataUpdateVehicleRequest,
} from './dataAdjustment';

// const UPDATE_VEHICLE = 'http://dev.teleportos.com/api/transport/vehicle/profile/{profile_id}';

export const updateVehicleRequest = async (profileId, data) => {
  const response = await RequestService.put(
    UPDATE_VEHICLE.replace('{profile_id}', profileId).replace(
      '{vehicle_id}',
      data.vehicleId
    ),
    { ...dataUpdateVehicleRequest(data) }
  );
  return dataAdjustmentCardResponse(response.data);
};
